import { useI18n } from '@app-velocity/i18n';
import { OpenIcon } from '@app-velocity/icons';

import { useScenarioDetailsContext } from '@app-velocity/modules/scenarios';

import { useAppContext } from '@app-velocity/config';

import { useSimulationWidgetContext } from '../../../../../../hooks/useSimulationWidgetContext';
import { ActionButton } from '../ActionButton';

export const ActionWebReport = () => {
  const { t } = useI18n();
  const { scenario } = useScenarioDetailsContext();
  const { AVMLink } = useAppContext();

  const { latestReview } = useSimulationWidgetContext();

  const openWebReport = () => {
    if (!latestReview) return;
    window.open(
      `${AVMLink}/report/${scenario.shareToken}`
    );
  };

  return (
    <ActionButton onClick={openWebReport}>
      {t('prototypes:open_web_report')}
      <OpenIcon />
    </ActionButton>
  );
};
